














































  import { Vue, Component, Prop } from "vue-property-decorator";
  import VesselFeatureChart from "./VesselFeatureChart.vue";

@Component({
  components: {
    VesselFeatureChart,
  },
})
  export default class OutlierTimelineModal extends Vue {
  @Prop({ required: true, type: Boolean }) value!: boolean;
  @Prop({ required: true, type: Number }) vesselId!: number;
  @Prop({ required: true, type: String }) vesselName!: string;
  @Prop({ required: true, type: String }) featureName!: string;
  @Prop({ required: true, type: String }) fromDate!: string;
  @Prop({ required: true, type: String }) toDate!: string;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit("input", value);
  }

  onChartLoaded(featureName: string): void {
    // Chart loaded successfully
  }

  onChartError(featureName: string): void {
    // Chart failed to load
  }

  close() {
    this.dialog = false;
  }
  }
